import { Injectable } from '@angular/core';
import { AttendeeStatus, EventAttendeeStatus, EventModel, OfflineActivity } from '../models';

@Injectable({
  providedIn: 'root'
})
export class AttendeeManagmentHelperService {
  constructor() { }

  public offlineActivityAttendeeEnabled(offlineActivity: OfflineActivity): boolean {
    return offlineActivity.attendeeStatus === AttendeeStatus.HAS_FREE_PLACE || offlineActivity.attendeeStatus === AttendeeStatus.REGISTERED;
  }

  public offlineActivityAttendeeButtonLabel(offlineActivity: OfflineActivity): string {
    switch (offlineActivity.attendeeStatus) {
      case AttendeeStatus.REGISTERED:
        return 'EVENT.click_to_cancel_attendance';
      case AttendeeStatus.HAS_FREE_PLACE:
        return 'EVENT.attend';
      default:
        return 'OFFLINE_ACTIVITY.no_free_seats';
    }
  }

  public eventAttendeeButtonLabel(event: EventModel): string {
    switch (event.attendeeStatus) {
      case EventAttendeeStatus.ATTENDEE_STATUS_REGISTERED:
        return 'EVENT.click_to_cancel_attendance';
      default:
        return 'EVENT.attend';
    }
  }

  public eventAttendeeEnabled(event: EventModel): boolean {
    return event.attendeeStatus !== EventAttendeeStatus.ATTENDEE_STATUS_PASSED;
  }

}
